import { EditIcon } from "@app/lib/events-admin-icons";
import { Spinner } from "@app/components/spinner";

/**
 * White-on-color spinner used inside the edit-page save controls. Centralizing
 * the color/track values avoids repeating the same magic strings across every
 * save button (DRY).
 */
export function SaveSpinner({ size = 16 }: { size?: number }) {
  return (
    <Spinner size={size} color="#fff" trackColor="rgba(255,255,255,0.4)" />
  );
}

type InlineSavePillProps = {
  /** Whether this specific control is the one currently being persisted. */
  saving: boolean;
  /** Whether any save is in progress (disables the control). */
  disabled: boolean;
  onSave: () => void;
};

/** Pill-shaped "Save" button that shows a spinner + "Saving" while persisting. */
export function InlineSavePill({
  saving,
  disabled,
  onSave,
}: InlineSavePillProps) {
  return (
    <button
      type="button"
      className="events-save-pill"
      onClick={onSave}
      disabled={disabled}
    >
      {saving ? (
        <span className="events-save-pill__content">
          <SaveSpinner />
          Saving
        </span>
      ) : (
        "Save"
      )}
    </button>
  );
}

type EditIconButtonProps = {
  disabled: boolean;
  onClick: () => void;
  label: string;
};

/** Circular pencil button used to enter edit mode for a field. */
export function EditIconButton({
  disabled,
  onClick,
  label,
}: EditIconButtonProps) {
  return (
    <button
      type="button"
      className="events-icon-button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <EditIcon className="size-4" />
    </button>
  );
}
